import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "logo" };
const _hoisted_3 = { class: "logo-text" };
const _hoisted_4 = ["aria-label", "aria-expanded"];
const _hoisted_5 = {
    key: 0,
    class: "main-nav"
};
const _hoisted_6 = { class: "nav-list" };
const _hoisted_7 = ["href", "onClick"];
const _hoisted_8 = {
    key: 1,
    class: "locale-switcher"
};
const _hoisted_9 = { class: "locale-dropdown" };
const _hoisted_10 = ["aria-label", "disabled"];
const _hoisted_11 = { class: "locale-code" };
const _hoisted_12 = {
    key: 0,
    class: "locale-dropdown-menu"
};
const _hoisted_13 = ["onClick", "onMouseenter", "aria-label", "disabled"];
const _hoisted_14 = { class: "locale-option-text" };
const _hoisted_15 = { class: "locale-option-code" };
const _hoisted_16 = { class: "mobile-nav" };
const _hoisted_17 = { class: "mobile-nav-list" };
const _hoisted_18 = ["href", "onClick"];
const _hoisted_19 = { class: "nav-link-text" };
const _hoisted_20 = { class: "mobile-locale-switcher" };
const _hoisted_21 = { class: "locale-buttons" };
const _hoisted_22 = ["onClick", "disabled"];
const _hoisted_23 = { class: "locale-button-code" };
const _hoisted_24 = { class: "locale-button-name" };
const _hoisted_25 = { class: "mobile-menu-footer" };
const _hoisted_26 = { class: "mobile-copyright" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_LocaleLoadingSpinner = _resolveComponent("LocaleLoadingSpinner");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("header", {
            class: _normalizeClass(["app-header", {
                    'app-header-loaded': _ctx.isLoaded,
                    'scrolled': _ctx.isScrolled
                }])
        }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_router_link, {
                        to: "/",
                        class: "logo-link",
                        onClick: _ctx.closeMobileMenu
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.studioName), 1)
                        ]),
                        _: 1
                    }, 8, ["onClick"])
                ]),
                _createElementVNode("button", {
                    class: _normalizeClass(["mobile-menu-toggle", { 'active': _ctx.isMobileMenuOpen }]),
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args))),
                    "aria-label": _ctx.isMobileMenuOpen ? 'Close menu' : 'Open menu',
                    "aria-expanded": _ctx.isMobileMenuOpen
                }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("div", { class: "burger-icon" }, [
                            _createElementVNode("span", { class: "burger-line" }),
                            _createElementVNode("span", { class: "burger-line" }),
                            _createElementVNode("span", { class: "burger-line" })
                        ], -1)
                    ]))], 10, _hoisted_4),
                (_ctx.navItems.length > 0)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_5, [
                        _createElementVNode("ul", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: item.id,
                                    class: "nav-item"
                                }, [
                                    _createElementVNode("a", {
                                        href: `#${item.id}`,
                                        class: _normalizeClass(["nav-link", { 'nav-link-active': _ctx.computedActiveSection === item.id }]),
                                        onClick: _withModifiers(($event) => (_ctx.handleNavClick(item.id)), ["prevent"])
                                    }, _toDisplayString(item.label), 11, _hoisted_7)
                                ]));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (!_ctx.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("button", {
                                class: "locale-current",
                                "aria-label": `Current language: ${_ctx.currentLocale.toUpperCase()}`,
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
                                disabled: _ctx.isLocaleChanging
                            }, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentLocale.toUpperCase()), 1),
                                (_openBlock(), _createElementBlock("svg", {
                                    class: _normalizeClass(["locale-arrow", { 'locale-arrow-open': _ctx.dropdownOpen }]),
                                    width: "12",
                                    height: "8",
                                    viewBox: "0 0 12 8",
                                    fill: "none"
                                }, [...(_cache[7] || (_cache[7] = [
                                        _createElementVNode("path", {
                                            d: "M1 1.5L6 6.5L11 1.5",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }, null, -1)
                                    ]))], 2))
                            ], 8, _hoisted_10),
                            (_ctx.dropdownOpen && !_ctx.isLocaleChanging)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLocales, (locale) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: locale.code,
                                            class: _normalizeClass(["locale-option", {
                                                    'locale-option-active': _ctx.currentLocale === locale.code,
                                                    'locale-option-hovered': _ctx.hoveredLocale === locale.code
                                                }]),
                                            onClick: ($event) => (_ctx.changeLocaleWithAnimation(locale.code)),
                                            onMouseenter: ($event) => (_ctx.hoveredLocale = locale.code),
                                            onMouseleave: _cache[2] || (_cache[2] = ($event) => (_ctx.hoveredLocale = null)),
                                            "aria-label": `Switch to ${locale.name}`,
                                            disabled: _ctx.isLocaleChanging
                                        }, [
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(locale.name), 1),
                                            _createElementVNode("span", _hoisted_15, _toDisplayString(locale.code.toUpperCase()), 1)
                                        ], 42, _hoisted_13));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.dropdownOpen && !_ctx.isLocaleChanging)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "dropdown-overlay",
                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.dropdownOpen = false))
                    }))
                    : _createCommentVNode("", true)
            ])
        ], 2),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_Transition, { name: "mobile-menu" }, {
                default: _withCtx(() => [
                    (_ctx.isMobileMenuOpen)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "mobile-menu-overlay",
                            onClick: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => (_ctx.closeMobileMenu && _ctx.closeMobileMenu(...args)))
                        }, [
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mobile-menu-backdrop" }, null, -1)),
                            _createElementVNode("div", {
                                class: "mobile-menu-container",
                                onClick: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"]))
                            }, [
                                _createElementVNode("nav", _hoisted_16, [
                                    _createElementVNode("ul", _hoisted_17, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: item.id,
                                                class: "mobile-nav-item"
                                            }, [
                                                _createElementVNode("a", {
                                                    href: `#${item.id}`,
                                                    class: _normalizeClass(["mobile-nav-link", { 'active': _ctx.computedActiveSection === item.id }]),
                                                    onClick: _withModifiers(($event) => (_ctx.handleNavClick(item.id)), ["prevent"])
                                                }, [
                                                    _createElementVNode("span", _hoisted_19, _toDisplayString(item.label), 1),
                                                    _cache[8] || (_cache[8] = _createElementVNode("svg", {
                                                        class: "nav-link-arrow",
                                                        width: "16",
                                                        height: "16",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            d: "M9 18L15 12L9 6",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round"
                                                        })
                                                    ], -1))
                                                ], 10, _hoisted_18)
                                            ]));
                                        }), 128))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLocales, (locale) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: locale.code,
                                                class: _normalizeClass(["locale-button", { 'active': _ctx.currentLocale === locale.code }]),
                                                onClick: ($event) => (_ctx.changeLocaleMobile(locale.code)),
                                                disabled: _ctx.isLocaleChanging
                                            }, [
                                                _createElementVNode("span", _hoisted_23, _toDisplayString(locale.code.toUpperCase()), 1),
                                                _createElementVNode("span", _hoisted_24, _toDisplayString(locale.name), 1)
                                            ], 10, _hoisted_22));
                                        }), 128))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, " © " + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString(_ctx.studioName), 1)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            })
        ])),
        _createVNode(_component_LocaleLoadingSpinner, { visible: _ctx.isLocaleChanging }, null, 8, ["visible"])
    ], 64));
}
